import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=0c42253d"
import script from "./personal-data.vue?vue&type=script&lang=js"
export * from "./personal-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports